import { Button, Drawer, message } from "antd";
import Input from "../../Components/CommonCommponents/Input";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import AuthService from "../../Service.js/authService";
import { useEffect, useState } from "react";
import { Alert } from "antd";
import toast from "react-hot-toast";
import RadioGroup from "../../Components/CommonCommponents/RadioGroup";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import Config from "../../Service.js/config";
// import layerimage from "././../../Assets/Icons/layer.jpeg";
import layerimage from "././../../Assets/Icons/layer-bg.png";
import { IoArrowBackSharp } from "react-icons/io5";

const Login = ({ handleClick, onClose, setPage }) => {
  const location = useLocation();
  const type = new URLSearchParams(location?.search).get("type");
  const navigate = useNavigate();
  const [messageApi, messageContextHolder] = message.useMessage();
  const [isprogress, setProgress] = useState(false);
  const [isFormError, setFormError] = useState(false);
  const [strFormType, setFormType] = useState();
  const [strMessage, setMessage] = useState();
  const [isCountryLayout, setCountryLayout] = useState(false);
  const [phoneCode, setPhonecode] = useState();
  const currentUser = JSON.parse(localStorage.getItem("candidate"));
  const [logo, setLogo] = useState();
  const pathname = window?.location?.origin;
  console.log("pathname", pathname);

  const {
    register,
    control,
    setError,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      is_employee_login_as_candidate: true,
    },
  });

  useEffect(() => {
    if (type) {
      localStorage.setItem("interview_type", type);
    }
  }, [type]);

  const isEmployee = watch("is_employee_login_as_candidate");
  useEffect(() => {
    if (isEmployee === "is_Staff") {
      window.open(`${window.location.origin}/login`, "_self");
    }
    if (isEmployee === "is_Recruiter") {
      window.open(`${window.location.origin}/OTPForm`, "_self");
    }
  }, [isEmployee]);
  const handelInputChange = (onChange, e) => {
    onChange(e);
    if (e.target.value !== "") {
      var test = Number(e.target.value);
      var test1 = Number.isInteger(test);
      if (test1) {
        setCountryLayout(true);
        setPhonecode("+91");
      } else {
        setCountryLayout(false);
        setPhonecode("");
      }
    } else {
      setCountryLayout(false);
      setPhonecode("");
    }
  };

  const handelChangePhone = (e) => {
    var value = `+${e}`;
    setPhonecode(value);
  };
  const ANSWER_OPTIONS = [
    { label: "Job Seeker", value: true },
    { label: "Recruiter", value: "is_Recruiter" },
    { label: "Employer", value: "is_Staff" },
  ];
  const handleRadio = (e, onChange) => {
    onChange(e);
    if (e.target.value == "false") {
      setValue("is_employee_login_as_candidate", "true");
    }
    setFormError(false);
    setValue("email_or_mobile_number", "");
    setValue("employee_identification_number");
  };
  const staffLogin = async (data) => {
    if (isCountryLayout) {
      data["email_or_mobile_number"] = phoneCode + data.email_or_mobile_number;
    } else {
      data["email_or_mobile_number"] = data.email_or_mobile_number;
    }
    data["employee_identification_number"] =
      data.employee_identification_number;

    await AuthService.staffLogin(data)
      .then(
        (oResponse) => {
          console.log("oResponse", oResponse.data.success);
          localStorage.setItem(
            "user_id",
            JSON.stringify(oResponse.data.data.user),
          );

          if (location.pathname.includes("jobDetails")) {
            onClose();
          } else if (oResponse.data.success == true) {
            navigate("/otp");
            // window.location.reload();
            setProgress(false);
          }
        },
        (error) => {
          console.log("loginError", error);
          const errorMessage = error.response.data.error_info.detail;
          console.log(errorMessage);
          setFormError(true);
          setFormType("error");
          setMessage(errorMessage);
          setProgress(false);
        },
      )
      .catch((err) => {
        console.log(err);
        setProgress(false);
      });
  };
  const onSubmit = async (data) => {
    console.log("isEmployee", isEmployee == "isStaff");
    data["is_candidate_login"] = true;
    data["company_domain"] = "http://ndz.yvi.com/";

    if (data.is_employee_login_as_candidate == "is_Staff") {
      data["is_employee_login_as_candidate"] = true;
    } else {
      data["is_employee_login_as_candidate"] = false;
    }

    if (isEmployee == true) {
      if (isCountryLayout) {
        data["email_or_mobile_number"] =
          phoneCode + data.email_or_mobile_number;
      } else {
        data["email_or_mobile_number"] = data.email_or_mobile_number;
      }
      await AuthService.candidateLogin(data)
        .then(
          (oResponse) => {
            console.log("oResponse", oResponse.data.success);
            localStorage.setItem(
              "user_id",
              JSON.stringify(oResponse.data.data.user),
            );

            if (location.pathname.includes("jobDetails")) {
              onClose();
            } else if (oResponse.data.success == true) {
              navigate("/otp");
              // window.location.reload();
              setProgress(false);
            }

            // requestPermission();
            //toast.success("Login successfully!");
          },
          (error) => {
            console.log("loginError", error);
            const errorMessage = error.response.data.error_info.detail;
            console.log(errorMessage);
            setFormError(true);
            setFormType("error");
            setMessage(errorMessage);
            setProgress(false);
          },
        )
        .catch((err) => {
          console.log(err);
          setProgress(false);
        });
    }
    if (isEmployee == "is_Staff") {
      staffLogin(data);
    }
  };

  const getLogo = async () => {
    if (currentUser) {
      await AuthService.getCompanyLogoWithLogin()
        .then((oResponse) => {
          console.log("oResponse", oResponse.data.data);
          setLogo(oResponse.data.data);
          //setSingleSelectValue({...singleSelectValue, [id]:dropDownOPtions(oResponse.data.data.prescreen_fields)})
        })
        .catch((err) => err);
    } else {
      await AuthService.getCompanyLogoWithoutLogin()
        .then((oResponse) => {
          console.log("oResponse", oResponse?.data?.data);
          setLogo(oResponse.data.data);
          //setSingleSelectValue({...singleSelectValue, [id]:dropDownOPtions(oResponse.data.data.prescreen_fields)})
        })
        .catch((err) => err);
    }
  };
  useEffect(() => {
    getLogo();
  }, []);

  return (
    <div className="flex w-full flex-col md:flex-row lg:flex-row  pb-10 md:pb-0">
      {/* flex w-full flex-col md:flex-row lg:flex-row min:h-full pb-10 md:pb-0 */}
      {/* Leftsection */}
      <section className="w-full md:w-[60%] flex flex-col px-8 gap-2 bg-white">
        {/* <>
          <div className="flex flex-wrap mt-8 space-x-6">
            <div className="flex items-center justify-end w-full">
              <div className="flex items-center justify-center gap-2 ml-4 md:gap-4">
                <p className="text-sm text-center text-gray-600 md:text-base sm:text-left">
                  Don't have an account?
                </p>
                <Link
                  to="/signup"
                  className="border border-blue-500 text-sm md:text-base px-3 md:px-5 py-1.5 md:py-2 rounded-md hover:text-white hover:bg-[#0071DC] transition duration-300 text-center mr-5 md:mr-0 "
                >
                  Sign Up Now
                </Link>
              </div>
            </div>
          </div>
        </> */}
        <p
          className="flex items-center gap-2 cursor-pointer font-medium"
          onClick={() => navigate("/")}
        >
          <IoArrowBackSharp />
          Back
        </p>

        <div className="pageContent scrollbar-hide  flex items-start mt-8 md:mt-0">
          <div className="w-full chart_div  mb-20 ">
            {/* <div className="flex items-center justify-center mt-20 mb-20 bg-white md:w-1/2 lg:w-1/3 xs-xl:w-1/4 2xl:w-1/4 rounded-xl"> */}
            <div className="w-[90%] md:w-[75%] flex flex-col gap-4 md:gap-10 mt-6 md:mt-0 sm:mt-0">
              <p className="text-3xl md:text-5xl font-semibold  px-0 md:px-14 lg:px-14 mt-6 lg:mt-5 md:mt-8 ">
                Sign In
              </p>
              {/* <p className="mt-4 ml-14 text-base font-semibold text-gray-500">
                  Hello! let's get started 
                </p> */}
              {isFormError && (
                <div className="px-0 md:px-14 lg:px-14 pb-12">
                  <Alert
                    message="Whoops !"
                    type={strFormType}
                    description={strMessage}
                    style={{ width: "100%", margin: "auto" }}
                  />
                </div>
              )}
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="px-0 md:px-14 lg:px-14">
                  {/* <p className="text-2xl font-semibold">Login</p> */}

                  {/* <div class="w-full  pt-4">
                    <RadioGroup
                      name="is_employee_login_as_candidate"
                      //defaultValue={props.experienceId ? experience?.current_company:""}
                      label=""
                      control={control}
                      rules={{
                        required: "At least 1 option must be chosen",
                      }}
                      onChange={(e, onChange) => handleRadio(e, onChange)}
                      options={ANSWER_OPTIONS}
                    />
                  </div> */}
                  <div>
                    <label className="mb-6 font-semibold text-lg ">Email</label>
                  </div>
                  {isEmployee == "is_Staff" &&
                    window.open(`${window.location.origin}/login`, "_self")}
                  {isEmployee == "is_Recruiter" &&
                    window.open(`${window.location.origin}/OTPForm`, "_self")}
                  <div
                    className={`w-full pt-2 ${
                      isEmployee == true ? "visible" : "invisible"
                    }`}
                  >
                    <div style={{ display: "flex" }}>
                      {isCountryLayout && (
                        <span
                          style={{
                            width: "10%",
                            paddingLeft: "5px",
                            paddingTop: "3px",
                            // marginTop: "46px",
                            paddingRight: "45px",
                          }}
                        >
                          <PhoneInput
                            country="In"
                            value="91"
                            inputStyle={{
                              height: "40px",
                              width: "2%",
                              paddingLeft: "0px",
                            }}
                            onChange={(e) => handelChangePhone(e)}
                          />
                        </span>
                      )}

                      <div className="w-[100%] md:w-[85%] lg:w-[85%] flex flex-col ">
                        <Input
                          //name="username"
                          name="email_or_mobile_number"
                          // label="Email ID or Phone Number"
                          control={control}
                          placeholder="Enter Registered Email"
                          className=" py-3"
                          //   isEmployee == true
                          //     ? "Email ID / Phone Number"
                          //     : "Email ID / Phone Number/Employee Id"
                          // }
                          rules={{
                            required: "This field is required",
                          }}
                          onChange={handelInputChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className={` ${
                      isEmployee == true ? "visible" : "invisible"
                    }`}
                  >
                    <button
                      // className="bg-[#1C4980] text-white w-full h-[42px] rounded-full"
                      className="bg-[#0071DC] text-white font-bold px-10 h-[46px] rounded-lg mt-2"
                      type="submit"
                    >
                      Continue
                    </button>{" "}
                  </div>
                  {/* <div
                  className={`flex items-center justify-center mt-16 ${
                    isEmployee == true ? "visible" : "invisible"
                  }`}
                >
                  <p className="text-xl text-[#748396]">
                    Don't have an account?
                  </p>
                  <Link to="/signup/" className="text-xl text-[#0073E6]">
                    Sign Up
                  </Link>
                </div> */}
                </div>
              </form>
              <div className="w-[100%] md:w-[85%] lg:w-[85%] px-[3rem]">
                <hr
                  style={{
                    width: "100%",
                    border: "none",
                    borderTop: "1px solid #B8B8B8",
                    margin: 0,
                  }}
                />
                <div className="flex items-center gap-3 mt-4">
                  <p className="text-[#000] font-sans">
                    Don’t have an account?
                  </p>
                  {/* <span className="text-[#0071DC] font-sans text-lg font-semibold cursor-pointer">
                    Sign Up Now
                  </span> */}
                  <Link
                    to="/signup"
                    className="text-[#0071DC] font-sans text-lg font-semibold cursor-pointer"
                  >
                    Sign Up Now
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Right Section */}

      <section
        className="relative flex flex-col md:flex  md:w-[40%] justify-center  items-center p-6 md:p-8"
        style={{
          background: "#F3FCF4",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Top Left Concentrated Blue */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "270px",
            height: "270px",
            borderRadius: "270px",
            background: "#0071DC",
            filter: "blur(130px)",
            opacity: 0.7,
            zIndex: 1,
          }}
        />
        {/* Bottom Left Concentrated Blue */}
        <div
          style={{
            position: "absolute",
            bottom: 0,
            left: 0,
            width: "270px",
            height: "270px",
            borderRadius: "270px",
            background: "#0071DC",
            filter: "blur(130px)",
            opacity: 0.7,
            zIndex: 1,
          }}
        />
        {/* Text Content */}
        <div className="text-center md:text-left mt-4 md:mt-12">
          <p className="text-xl md:text-2xl font-bold text-[#00175e]">
            Land your Dream Job
          </p>
          <h2 className="text-3xl md:text-4xl font-bold text-[#00175e] mt-2 md:mt-3">
            {/* Book Your AI Interview */}
            {type ? type : "Book Your AI Interview"}
          </h2>
        </div>
        <div className="">
          <img
            src={layerimage}
            alt="Illustration"
            className="w-4/4 max-w-xs md:max-w-lg mb-6 md:mb-0 "
          />
        </div>
      </section>
    </div>
  );
};
export default Login;
